export const PriceListsMap = [
    { id: 14972, name: "MAISON DU LIBAN" },
    { id: 70176, name: "Marché d'Alep" }
];